/* eslint-disable brace-style */
/* eslint-disable no-trailing-spaces */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-confusing-arrow */
/* eslint-disable object-curly-newline */
/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable eqeqeq */
/* eslint-disable arrow-body-style */
import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import { useTranslation } from '@i18n';
import { breakPointsUp } from '@helper_theme';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import CancelIcon from '@material-ui/icons/Cancel';
import EventIcon from '@material-ui/icons/Event';

import {
    DateRangePicker,
    LocalizationProvider,
    DateRangeDelimiter,
} from '@material-ui/pickers';
import DateFnsUtils from '@material-ui/pickers/adapter/date-fns';

import { useColumns, getComponentOrString } from '@common_tableseller/helpers';
import TextField from '@common_textfield';
import Button from '@common_button';
import ConfirmDialog from '@common_confirmdialog';
import formatDate, { getMinDate } from '@helper_date';

import TablePaginationActions from '@common_tableseller/components/TablePaginationActions';
import TabsHeader from '@common_tableseller/components/TabsHeader';
import RowAction from '@common_tableseller/components/RowAction';
import TableFilters from '@common_tableseller/components/Filter';
import FilterApplied from '@common_tableseller/components/FilterApplied';

import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import ImportExportIcon from '@material-ui/icons/ImportExport';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';

import useStyles from '@common_tableseller/style';

const CustomTable = (props) => {
    const { t } = useTranslation('common');
    const {
        primaryKey = 'id',
        showCheckbox = false,
        rows,
        rowActions,
        getRows,
        loading,
        toolActionsRight = [],
        toolActionsLeft = [],
        filters: initialFilters = [],
        initialPage = 1,
        initialRowsPerPage = 10,
        rowsPerPageOptions = [5, 10, 25, 100],
        count,
        hideHead = false,
        hideSearch = false,
        hideFilters = false,
        hideFooter = false,
        hideTitle = false,
        hideToolbar = false,
        useDateRange = false,
        handleClickRow = null,
        wrapHeader = false,
        getVariables,
        doRefetch = null,
        setDoRefetch = () => { },
        handleChecked = () => { },
        defaultChecked = [],
        singleSelection = false,
        header = '',
        searchPlaceholder = '',
        useTabs = false,
        dataTab = [],
        defaultValueTab = '',
        filterFieldDateRange = [
            {
                field: 'date',
                name: 'date_from',
                type: 'from',
                value: '',
                format: 'date',
                label: t('common:Date_From'),
            },
            {
                field: 'date',
                name: 'date_to',
                type: 'to',
                value: '',
                format: 'date',
                label: t('common:Date_To'),
            },
        ],
        rangeDate = 1,
        limitDate,
        fetchVariables = {},
    } = props;
    // hooks
    const desktop = breakPointsUp('sm');
    const classes = useStyles();
    const [page, setPage] = useState(initialPage);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [rowsPerPage, setRowsPerPage] = useState(initialRowsPerPage);
    const [isCheckedAllRows, setIsCheckedAllRows] = useState(false);
    const [showMessageActions, setShowMessageActions] = useState(true);
    const [checkedRows, setCheckedRows] = useState(defaultChecked);
    const [search, setSearch] = useState('');
    const [selectedId, setSelectedId] = useState();
    const [tab, setTab] = useState(defaultValueTab || dataTab?.[0]?.value || 0);
    const {
        columns,
        applyHiddenColumnsDesktop,
        applyHiddenColumnsMobile,
    } = useColumns(props.columns);
    const [filters, setFilters] = useState(initialFilters.map((filter) => ({ ...filter, value: filter.initialValue })));
    const [expandedToolbar, setExpandedToolbar] = useState(false);
    const [sorts, setSorts] = useState(
        props.columns.filter((column) => column.sortable).map(({ field, initialSort }) => ({ field, value: initialSort || undefined })),
    );
    const [selectedDate, setSelectedDate] = useState([formatDate(limitDate ? getMinDate(limitDate) : new Date()
        .setMonth(new Date().getMonth() - rangeDate, new Date().getDate()), 'YYYY-MM-DD 00:00:00'),
    formatDate(new Date(), 'YYYY-MM-DD 23:59:59')]);
    const [activeAction, setActiveAction] = useState();

    const useDebounce = (value, delay) => {
        const [debouncedValue, setDebouncedValue] = useState(value);

        useEffect(() => {
            const handleTimeout = setTimeout(() => {
                setDebouncedValue(value);
            }, delay);
            return () => {
                clearTimeout(handleTimeout);
            };
        }, [value]);
        return debouncedValue;
    };

    const debouncedSearch = useDebounce(search, 500);

    // methods
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(1);
    };
    const fetchRows = () => {
        const isEmpty = (value) => {
            if ([undefined, null, '', false].includes(value)) return true;
            if (value && value.length <= 0) return true;
            return false;
        };
        const variables = {
            pageSize: rowsPerPage,
            currentPage: page,
            filter: filters
                .filter((e) => useDateRange ? e.field !== filterFieldDateRange.field : e)
                .filter((e) => (e.children?.length && isEmpty(e.value)) || (!e.children?.length && !isEmpty(e.value)))
                .reduce((accumulator, currentValue) => {
                    if (currentValue.children?.length) {
                        currentValue.children.filter((child) => !isEmpty(child.value))
                            .forEach((child) => {
                                accumulator[child.field] = {
                                    ...accumulator[child.field],
                                    [child.type]: typeof child.value === 'object'
                                        ? child.type === 'in'
                                            ? child.value.map((val) => typeof val === 'object' ? String(val[child.primaryKey || 'value']) : val)
                                            : String(child.value[child.primaryKey || 'value'])
                                        : String(child.value),
                                };
                            });
                    } else {
                        let condition = {
                            [currentValue.type]: typeof currentValue.value === 'object'
                                ? currentValue.type === 'in'
                                    ? currentValue.value.map((val) => typeof val === 'object' ? String(val[currentValue.primaryKey || 'value']) : val)
                                    : String(currentValue.value[currentValue.primaryKey || 'value'])
                                : String(currentValue.value),
                        };
                        if (currentValue.type === 'comma_separator') {
                            if (currentValue.value?.includes(',')) {
                                condition = { in: String(currentValue.value)?.split(',') };
                            } else {
                                condition = { like: String(currentValue.value) };
                            }
                        }
                        accumulator[currentValue.field] = {
                            ...accumulator[currentValue.field],
                            ...condition,
                        };
                    }
                    return accumulator;
                }, useDateRange
                    ? {
                        [filterFieldDateRange[0].field]: {
                            from: selectedDate[0],
                            to: selectedDate[1],
                        },
                    }
                    : {}),
            sort: sorts.reduce((accumulator, currentValue) => {
                accumulator[currentValue.field] = currentValue.value || undefined;
                return accumulator;
            }, useDateRange ? {} : {}),
            search,
            ...fetchVariables,
        };
        if (getVariables) {
            getVariables(variables);
        }
        getRows({ variables });
    };

    const setHiddenResponsive = () => {
        if (!desktop) {
            applyHiddenColumnsMobile();
        } else {
            applyHiddenColumnsDesktop();
        }
    };

    const handleDateChange = async (e) => {
        const formattedDate = [formatDate(e[0], 'YYYY-MM-DD 00:00:00'), formatDate(e[1], 'YYYY-MM-DD 23:59:59')];
        if (!selectedDate.every((date) => date === null)) {
            setSelectedDate(e);
        }

        if (selectedDate[0] !== formattedDate[0] || selectedDate[1] !== formattedDate[1]) {
            if (!selectedDate.every((date) => date === null)) {
                setSelectedDate([e[0], e[1]]);
            }
        }
    };

    const handleDateClose = () => {
        if (!selectedDate.every((date) => date === null)) {
            handleDateChange(selectedDate);
        }
    };

    // effects
    useEffect(() => {
        if (getRows) {
            setPage(1);
            fetchRows();
        }
    }, [rowsPerPage, filters, sorts, debouncedSearch, tab, selectedDate]);

    useEffect(() => {
        if (getRows) {
            fetchRows();
        }
    }, [page]);

    useEffect(() => {
        if (doRefetch !== null) {
            fetchRows();
            setDoRefetch(null);
        }
    }, [doRefetch]);

    useEffect(() => {
        if (defaultChecked.length) {
            setCheckedRows(defaultChecked);
        }
    }, [defaultChecked]);

    useEffect(() => {
        setHiddenResponsive();
    }, [desktop]);

    const contentProps = {
        ...props,
        filters,
        setFilters,
        setSearch,
        search,
        fetchRows,
        setExpandedToolbar,
        expandedToolbar,
        tab,
        setTab,
        initialFilters,
        columns,
        t,
    };

    const renderHead = () => {
        const getArrowClass = (anchor) => (anchor ? classes.arrowUp : classes.arrowDown);
        return (
            <>
                {!hideTitle
                    && (
                        <div className={classes.header}>
                            {header}
                        </div>
                    )}
                {!hideToolbar
                    && (
                        <div className={classes.tableToolbar}>
                            <div className="top-buttons-wrapper">
                                <div className="top-item-left">
                                    {!hideSearch
                                        && (
                                            <div className="top-item">
                                                <TextField
                                                    name="email"
                                                    placeholder={searchPlaceholder}
                                                    value={search}
                                                    onChange={(e) => setSearch(e.target.value)}
                                                    className={classes.textInput}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <img alt="" src="/assets/img/search.svg" className={classes.iconImg} />
                                                            </InputAdornment>
                                                        ),
                                                        endAdornment: search === '' ? false : (
                                                            <InputAdornment position="end">
                                                                <IconButton onClick={() => setSearch('')} classes={{ root: classes.cancelSearch }}>
                                                                    <CancelIcon />
                                                                </IconButton>
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                            </div>
                                        )}

                                    {toolActionsLeft.length
                                        ? (
                                            <div className="top-item-right">
                                                {toolActionsLeft.map((component) => (
                                                    <div className="top-item">
                                                        {component}
                                                    </div>
                                                ))}
                                            </div>
                                        )
                                        : null}
                                </div>
                                <div className="top-item-right">
                                    {toolActionsRight.length
                                        ? (toolActionsRight.map((component) => (
                                            <div className="top-item">
                                                {component}
                                            </div>
                                        ))
                                        )
                                        : null}
                                    {!hideFilters && !!filters.length
                                        && (
                                            <div className="top-item">
                                                <Button
                                                    className={clsx(classes.btnAction, 'filter')}
                                                    onClick={() => setExpandedToolbar(expandedToolbar != 'filters' ? 'filters' : '')}
                                                    endIcon={
                                                        <KeyboardArrowRightIcon className={getArrowClass(expandedToolbar)} />
                                                    }
                                                >
                                                    <span className={classes.btnText}>
                                                        {t('common:Filters')}
                                                    </span>
                                                </Button>
                                            </div>
                                        )}
                                    {useDateRange
                                        && (
                                            <div className="top-item">
                                                <LocalizationProvider dateAdapter={DateFnsUtils}>
                                                    <DateRangePicker
                                                        className={classes.dateRangeClass}
                                                        startText=""
                                                        endText=""
                                                        allowSameDateSelection
                                                        value={selectedDate}
                                                        inputFormat="dd MMM yyyy"
                                                        onChange={setSelectedDate}
                                                        toolbarPlaceholder="-"
                                                        onAccept={(date) => handleDateChange(date)}
                                                        clearable
                                                        onClose={handleDateClose}
                                                        minDate={limitDate && formatDate(getMinDate(limitDate), 'YYYY-MM-DD 00:00:00')}
                                                        maxDate={limitDate && formatDate(new Date(), 'YYYY-MM-DD 23:59:59')}
                                                        renderInput={(startProps, endProps) => (
                                                            <div className={classes.dateContainer}>
                                                                <EventIcon />
                                                                <TextField
                                                                    className={classes.inputDate}
                                                                    {...startProps.inputProps}
                                                                    placeholder="From"
                                                                    onChange={(e) => e.preventDefault}
                                                                />
                                                                <DateRangeDelimiter> - </DateRangeDelimiter>
                                                                <TextField
                                                                    className={classes.inputDate}
                                                                    {...endProps.inputProps}
                                                                    placeholder="To"
                                                                    onChange={(e) => e.preventDefault}
                                                                />
                                                            </div>
                                                        )}
                                                    />
                                                </LocalizationProvider>
                                            </div>
                                        )}
                                </div>
                            </div>
                            {!hideFilters && !!filters.length
                                && (
                                    <TableFilters
                                        {...contentProps}
                                        t={t}
                                        columns={columns}
                                        resettedFilter={initialFilters.map((filter) => ({ ...filter, value: filter.initialValue }))}
                                        initialFilters={filters}
                                        setParentFilters={setFilters}
                                        expandedToolbar={expandedToolbar}
                                        setExpandedToolbar={setExpandedToolbar}
                                    />
                                )}
                        </div>
                    )}
            </>
        );
    };

    const renderAction = (row) => {
        return (
            <>
                <button
                    id="clickConfirm"
                    className="hide"
                    type="submit"
                    onClick={async () => {
                        if (selectedId >= 0) {
                            await activeAction.onClick(row);
                            if (activeAction.refetch !== false) {
                                fetchRows();
                                setCheckedRows([]);
                            }
                            if (showMessageActions) {
                                window.toastMessage({
                                    open: true,
                                    text: t('common:Success'),
                                    variant: 'success',
                                });
                            }
                        }
                    }}
                >
                    Auto Confirm
                </button>
                <RowAction
                    openButton={{ label: '' }}
                    icon={<ExpandMoreIcon />}
                    menuItems={rowActions.map((action) => ({
                        label: action.label,
                        hide: action.hide,
                        onClick: () => {
                            setSelectedId(row.id);
                            const tempAction = { ...action };
                            setActiveAction(tempAction);
                            if (tempAction.showMessage !== null) {
                                setShowMessageActions(tempAction.showMessage);
                            } else {
                                setShowMessageActions(false);
                            }
                            if (tempAction.confirmDialog) {
                                setOpenConfirmDialog(true);
                            } else {
                                setTimeout(() => {
                                    document.getElementById('clickConfirm').click();
                                }, 100);
                            }
                        },
                    }))}
                />
            </>
        );
    };

    const renderTableHeader = () => {
        const handleChangeCheckboxAllRows = (checked) => {
            const newCheckedRows = rows.reduce((accumulator, currentValue) => {
                const i = accumulator.findIndex((checkedRow) => checkedRow[primaryKey] === currentValue[primaryKey]);
                if (checked && i < 0) {
                    accumulator.push(currentValue);
                } else if (!checked && i >= 0) {
                    return accumulator.filter((checkedRow) => checkedRow[primaryKey] != currentValue[primaryKey]);
                }
                return accumulator;
            }, checkedRows);
            setCheckedRows(newCheckedRows);
            setIsCheckedAllRows(checked);
            handleChecked(newCheckedRows);
        };

        const setSortByField = (field) => {
            setSorts(
                sorts.map((sort) => ({
                    ...sort,
                    ...(sort.field === field && { value: sort.value === 'ASC' ? 'DESC' : 'ASC' }),
                    ...(sort.field != field && { value: undefined }),
                })),
            );
        };
        const getSortValue = (field) => {
            const sort = sorts.find((e) => e.field === field);
            return sort && sort.value;
        };
        const getArrowClass = (field) => (getSortValue(field) === 'ASC' ? classes.arrowDown : classes.arrowUp);
        return (
            <TableHead>
                <TableRow className={classes.tableHead}>
                    {showCheckbox && (
                        <TableCell padding="checkbox">
                            {!singleSelection
                                && (
                                    <Checkbox
                                        className={classes.checkbox}
                                        checked={isCheckedAllRows}
                                        onChange={(e) => handleChangeCheckboxAllRows(e.target.checked)}
                                    />
                                )}
                        </TableCell>
                    )}
                    {columns.map((column, columnIndex) => (
                        <TableCell
                            key={columnIndex}
                            className={clsx(column.hidden && 'hide')}
                            style={{ whiteSpace: wrapHeader ? 'unset' : 'nowrap', verticalAlign: wrapHeader ? 'top' : '' }}
                        >
                            {!column.sortable && getComponentOrString(column.headerName)}
                            {column.sortable && (
                                <Button
                                    onClick={() => setSortByField(column.field)}
                                    className={classes.sortButon}
                                    buttonType="link"
                                    endIcon={
                                        getSortValue(column.field) ? (
                                            <ArrowRightAltIcon className={getArrowClass(column.field)} />
                                        ) : (
                                            <ImportExportIcon style={{ opacity: 0.3 }} />
                                        )
                                    }
                                >
                                    {column.headerName}
                                </Button>
                            )}
                        </TableCell>
                    ))}
                    {!!rowActions?.length
                        && (
                            <TableCell
                                style={{ whiteSpace: wrapHeader ? 'unset' : 'nowrap', verticalAlign: wrapHeader ? 'top' : '' }}
                                padding="checkbox"
                            >
                                {t('common:Action')}
                            </TableCell>
                        )}
                </TableRow>
            </TableHead>
        );
    };

    const renderTableBody = () => {
        const handleChangeCheckboxRow = (checked, row) => {
            const i = checkedRows.findIndex((checkedRow) => checkedRow[primaryKey] === row[primaryKey]);
            if (singleSelection) {
                setCheckedRows([row]);
                handleChecked([row]);
            } else if (checked && i < 0) {
                setCheckedRows([...checkedRows, row]);
                handleChecked([...checkedRows, row]);
            } else if (!checked && i >= 0) {
                setCheckedRows(checkedRows.filter((checkedRow) => checkedRow[primaryKey] != row[primaryKey]));
                handleChecked(checkedRows.filter((checkedRow) => checkedRow[primaryKey] != row[primaryKey]));
            }
        };
        const rowsToMap = getRows || hideFooter ? rows : rows.slice(rowsPerPage * (page - 1), rowsPerPage * (page - 1) + rowsPerPage);
        return (
            <TableBody>
                {rowsToMap.map((row, rowIndex) => (
                    <TableRow
                        key={rowIndex}
                        onClick={() => (handleClickRow ? handleClickRow(row) : null)}
                        style={{
                            cursor: handleClickRow ? 'pointer' : 'default',
                        }}
                        className={clsx(classes.tableRow, rowIndex % 2 && 'gray')}
                    >
                        {showCheckbox && (
                            <TableCell padding="checkbox">
                                <Checkbox
                                    className={classes.checkbox}
                                    checked={!!checkedRows.find((checkedRow) => checkedRow[primaryKey] === row[primaryKey])}
                                    onChange={(e) => handleChangeCheckboxRow(e.target.checked, row)}
                                    disabled={!checkedRows.find((checkedRow) => checkedRow[primaryKey] === row[primaryKey]) && row.disableCheck}
                                />
                            </TableCell>
                        )}
                        {columns.map((column, columnIndex) => (
                            <TableCell key={columnIndex} className={clsx(column.hidden && 'hide', classes.align, column.align || 'top')}>
                                {getComponentOrString(row[column.field]) || ''}
                            </TableCell>
                        ))}
                        {!!rowActions?.length
                            && (
                                <TableCell className={clsx(classes.alignTop)} padding="checkbox">
                                    {renderAction(row)}
                                </TableCell>
                            )}
                    </TableRow>
                ))}
            </TableBody>
        );
    };

    const renderTableFooter = () => {
        return (
            <>
                <TableFooter>
                    <TableRow>
                        <TablePagination
                            className={classes.tablePagination}
                            rowsPerPageOptions={rowsPerPageOptions}
                            count={count}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            labelRowsPerPage={t('common:View')}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            labelDisplayedRows={() => { }}
                            ActionsComponent={TablePaginationActions}
                        />
                    </TableRow>
                </TableFooter>
            </>
        );
    };

    return (
        <>
            <TableContainer component={Paper} className={classes.tableContainer}>
                {useTabs && <TabsHeader {...contentProps} />}
                {!hideHead && !useTabs && renderHead()}
                {!hideFilters && <FilterApplied {...contentProps} />}
                <div className={classes.mainTable}>
                    <Table size="small">
                        {renderTableHeader()}
                        {loading ? (
                            null
                        ) : rows.length ? (
                            renderTableBody()
                        ) : (
                            null
                        )}
                    </Table>
                    {loading || !rows.length
                        ? (
                            <Table size="small">
                                <TableBody>
                                    <TableRow>
                                        <TableCell>
                                            {loading ? (
                                                <div className={classes.loading}>Loading . . .</div>
                                            ) : !rows.length ? (
                                                <div className={classes.loading}>{t('common:No_records_to_display')}</div>
                                            ) : (
                                                null
                                            )}
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        )
                        : null}
                </div>
            </TableContainer>
            <TableContainer component={Paper} className={clsx(classes.tableContainer, 'footer')}>
                <Table size="small">{!hideFooter && renderTableFooter()}</Table>
            </TableContainer>
            <ConfirmDialog
                open={openConfirmDialog}
                onCancel={() => setOpenConfirmDialog(false)}
                onConfirm={async () => {
                    window.backdropLoader(true);
                    if (selectedId >= 0) {
                        setOpenConfirmDialog(false);
                        await activeAction.onClick(selectedId);
                        if (activeAction.refetch !== false) {
                            fetchRows();
                        }
                        if (showMessageActions) {
                            window.toastMessage({
                                open: true,
                                text: t('common:Success'),
                                variant: 'success',
                            });
                        }
                    }
                    setCheckedRows([]);
                    setOpenConfirmDialog(false);
                    window.backdropLoader(false);
                }}
                title={activeAction && activeAction.title}
                message={activeAction && activeAction.message}
            />
        </>
    );
};

export default CustomTable;
